import React, { Component } from 'react';
import SearchBar from '../SearchBar';
import './styles.scss';
import Radio from '../Radio';

type Props = {
  options: any;
  onSelect: Function;
  placeholder: string;
};
type State = {
  searchValue: string;
  selectedIndex: number;
};

export default class SearchOptions extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.onSearch = this.onSearch.bind(this);
  }

  setInitialState(): State {
    return {
      searchValue: '',
      selectedIndex: -1,
    };
  }

  onSearch(term: string) {
    this.setState({
      searchValue: term,
    });
  }

  onSelectionChange(index: number, queueId: number) {
    this.setState({
      selectedIndex: index,
    });

    this.props.onSelect(queueId);
  }

  get options(): any {
    const searchTerm = this.state.searchValue.toLowerCase();
    return this.props.options.filter(
      (option: any) =>
        option.queueName.toLowerCase().indexOf(searchTerm) >= 0 &&
        option.queueName !== 'All Queues' &&
        option.status !== 'deleted'
    );
  }

  render() {
    return (
      <div className='sf-search-options'>
        <SearchBar icon='search' onSearch={this.onSearch} placeholder='Search queue' />
        <div id='search-options-wrapper'>
          {this.options.length > 0 ? this.options.map((option: any, index: number) => {
            return (
              <Radio
                label={
                  option.queueName.charAt(0).toUpperCase() +
                  option.queueName.slice(1).replace('GS', '')
                }
                id={'radio_' + index}
                key={option.queueName.replace('GS', '') + '-' + index}
                checked={this.state.selectedIndex === index}
                onSelect={() => {
                  this.onSelectionChange(index, option.queueId);
                }}
              />
            );
          }) : <div className="notransferQueue">Currently there are no other Queues available to transfer this chat, you can try to release the chat</div>}
        </div>
      </div>
    );
  }
}
